import {
    initialCounsellingsHomePageState,
    initialCounsellingsHomePostsState,
    CounsellingsHomePageState,
    CounsellingsHomePostsState,
} from 'mk2/apps/counsellings/containers/CounsellingsHome/CounsellingsHome.reducers';
import { getForumComplaintsStatistics } from 'mk2/apps/forum/reducers';
import { ComplaintsCountPerTopic, CounsellingEntity, CounsellingSchema } from 'mk2/apps/forum/schemas';
import { AppState } from 'mk2/reducers';
import { getDenormalizedEntities } from 'mk2/selectors';
import { createSelector } from 'reselect';

export const getCounsellingsHomePageState = (state: AppState): CounsellingsHomePageState =>
    state.containers.counsellings.home || initialCounsellingsHomePageState;

export const getCounsellingsHomePostsState = (state: AppState, query: string): CounsellingsHomePostsState =>
    getCounsellingsHomePageState(state).search[query] || initialCounsellingsHomePostsState;

export const getCounsellingsHomeComplaintsStatisticsPerTopic = createSelector(
    [
        (state: AppState, query: string) => getDenormalizedEntities<CounsellingEntity>(state, CounsellingSchema, getCounsellingsHomePageState(state).counsellingIds),
        (state: AppState) => getForumComplaintsStatistics(state),
    ],
    (counsellings, complaintsStatistics) => {
        if (!counsellings.length) {
            return {};
        }

        const keys = Object.keys(complaintsStatistics).map((k) => parseInt(k, 10));
        return counsellings.reduce((acc: ComplaintsCountPerTopic, cur: CounsellingEntity) => {
            acc[cur.topic.id] = keys.reduce((acc2, cur2) => {
                const current = complaintsStatistics[cur2];
                if (!current || current.topicId !== cur.topic.id) {
                    return acc2;
                }

                return acc2 + current.count;
            }, 0);
            return acc;
        }, {});
    },
);
